import { render, staticRenderFns } from "./VdoSetInfo.vue?vue&type=template&id=0f62522e&scoped=true&"
import script from "./VdoSetInfo.vue?vue&type=script&lang=js&"
export * from "./VdoSetInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f62522e",
  null
  
)

export default component.exports